import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlacesService from "../../services/places.service";

// **Async Thunks**
export const addPlace = createAsyncThunk(
  "places/addPlace",
  async (item, thunkAPI) => {
    try {
      const response = await PlacesService.addPlace(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPlaceList = createAsyncThunk(
  "places/getPlaceList",
  async (item, thunkApi) => {
    try {
      const response = await PlacesService.getplaceList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editPlaces = createAsyncThunk(
  "places/editPlace",
  async (item, thunkAPI) => {
    try {
      const response = await PlacesService.editPlace(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletePlace = createAsyncThunk(
  "places/deletePlace",
  async (id, thunkAPI) => {
    try {
      await PlacesService.deletePlace(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  places: [],
};

// **Slice**
const placeSlice = createSlice({
  name: "places",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Places List**
      .addCase(getPlaceList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getPlaceList.fulfilled, (state, action) => {
        state.loading = false;
        state.places = action.payload;
      })
      .addCase(getPlaceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Place**
      .addCase(addPlace.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPlace.fulfilled, (state, action) => {
        state.loading = false;
        state.places.push(action.payload);
      })
      .addCase(addPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Place**
      .addCase(editPlaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(editPlaces.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.places.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.places[index] = action.payload;
        }
      })
      .addCase(editPlaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Place**
      .addCase(deletePlace.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePlace.fulfilled, (state, action) => {
        state.loading = false;
        state.places = state.places.filter((p) => p.id !== action.payload);
      })
      .addCase(deletePlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default placeSlice.reducer;
